/** Texto para busca: sem acentos e sem diferença de maiúsculas ("Gonçalves" → "goncalves"). */
export const foldText = (value: string): string =>
  (value || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();

/**
 * Bloco #72: filtra pelo trecho digitado em qualquer posição do texto exibido
 * (nome ou código), em ordem alfabética.
 */
export function searchByName<T extends { name: string }>(items: T[], query: string): T[] {
  const q = foldText(query);
  const sorted = [...items].sort((a, b) => a.name.localeCompare(b.name, 'pt-BR', { sensitivity: 'base' }));
  return q ? sorted.filter((item) => foldText(item.name).includes(q)) : sorted;
}
